import { Injectable, Optional } from '@angular/core';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { RESPONSE_SUCCESS_LOGGED_IN_USER } from '../actions';
import * as actions from './remote-config.actions';

@Injectable()
export class RemoteConfigEffects {
  @Effect()
  remoteConfigUpdates$ = this.remoteConfig
    ? this.actions$.pipe(
        ofType(RESPONSE_SUCCESS_LOGGED_IN_USER),
        switchMap(() => this.remoteConfig.changes),
        map((data) => new actions.SetRemoteConfig(data))
      )
    : of(new actions.RemoteConfigNotAvailable());

  constructor(
    private actions$: Actions<any>,
    @Optional() private remoteConfig: AngularFireRemoteConfig
  ) {}
}
